/**
 * UUID v4 generator shared by callers that need a client-owned identifier
 * before the first request reaches the backend.
 *
 * Two unrelated flows depend on this: the OAuth `state` nonce, and the
 * `participant_external_id` the backend requires on mice/internal pickups
 * (it is generated once per participant and replayed unchanged on retry, so
 * a lost HTTP response cannot become a second MEWS booking).
 */

/** Cheap UUID v4 generator. */
export function uuid(): string {
  // crypto.randomUUID is available in all evergreen browsers + iOS 14+.
  // It also requires a secure context, so the fallback covers plain-HTTP hosts.
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return (crypto as any).randomUUID()
  }
  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}
